import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import { LoadingIcon } from '../../Common/Loading_Icon';
import DatePicker from '../../Common/DatePicker.jsx';

import Select from 'react-select';
import Slider from 'rc-slider';
import { setList, setOverlay } from '../../../Actions/stakeholderActions';
import { setSidebar, setListEndUser } from '../../../Actions/endUserActions';
import { constants } from '../../../Helpers/Constants';

import { checkCredentials } from '../../../Helpers/checkCredentials.js';
import { Trans } from 'react-i18next';

class MediaOverlay extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            media_details: {},
            form_details: {user: null, vehicle: null, link: "", title: "", date_published: "", rating_check: false, media_rating: null, description: null},
            loaded_media: false,
            edit: false,
            selectedUser: null, selectedVehicle: null,
        };

        this.setupOverlay = this.setupOverlay.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.updateVehicle = this.updateVehicle.bind(this);
        this.handleSubmit = debounce(this.handleSubmit.bind(this), 500);
        this.changeRating = this.changeRating.bind(this);
        this.updateMediaVehicleList = this.updateMediaVehicleList.bind(this);

    }

    componentDidMount() {
        this.setupOverlay(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.action !== this.props.match.params.action) {
            this.setupOverlay(nextProps)
        }
    }
    
    setupOverlay(props) {
        var url = "";
        var self = this;

        if(props.action == "create") {
            url = "ajax/media";
        }
        else if (props.match.params.id != undefined && props.match.params.action == "create") {
            url = "ajax/media/" + props.match.params.id + "/create";
        }
        else if (props.match.params.id != undefined && props.match.params.action == "edit") {
            url = "ajax/media/" + props.match.params.id + "/edit";
        }
        else if (props.match.params.id != undefined && props.match.params.action == "show"){
            url = "ajax/media/" + props.match.params.id;
        }

        if(url != "") {
            axios.get(url)
            .then((response) => {

                if(props.action != "create") {
                    self.state.form_details.user = response?.data.view.users[0].ID;
                    self.state.selectedUser = {label: response?.data.view.users[0].First_Name + " " + response?.data.view.users[0].Last_Name, value: response?.data.view.users[0].ID};
                    self.state.form_details.vehicle = response?.data.view.vehicles[0].V_ID;
                    self.state.selectedVehicle = {label: response?.data.view.vehicles[0].Year + " " + response?.data.view.vehicles[0].Make + " " + response?.data.view.vehicles[0].Model + " " + response?.data.view.vehicles[0].Trim, value: response?.data.view.vehicles[0].V_ID};
                }

                self.state.form_details.link = response?.data.view.media.link;
                self.state.form_details.title = response?.data.view.media.title;
                self.state.form_details.date_published = response?.data.view.media.date_published;
                self.state.form_details.rating_check = response?.data.view.media.active_rating;
                self.state.form_details.media_rating = response?.data.view.media.rating;
                self.state.form_details.description = response?.data.view.media.description;

                self.setState({
                    media_details: response?.data.view,
                    loaded_media: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
    }

    updateForm(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var form_details = this.state.form_details;
        form_details[name] = value;

        this.setState({
            form_details: form_details
        });
    }

    updateUser(option) {
        var form_details = this.state.form_details;
        form_details["user"] = option.value;

        this.setState({
            form_details: form_details,
            selectedUser: option
        });

        this.updateMediaVehicleList(option.value);
    }

    updateVehicle(option) {
        var form_details = this.state.form_details;
        form_details["vehicle"] = option.value;

        this.setState({
            form_details: form_details,
            selectedVehicle: option
        });
    }

    updateMediaVehicleList(value) {
        axios.get('/ajax/media/vehicle_list/' + value)
            .then((response) => {
                let newState = Object.assign({}, this.state);
                newState.media_details.vehicles = response?.data.vehicles;
                this.setState(newState);
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    handleSubmit() {
        var self = this;
        var url = '';

        if(this.state.media_details.primary_button_action == 'store') {
            if(this.props.match.params.id != undefined) {
                url = '/ajax/media/' + this.props.match.params.id;
            } else {
                url = '/ajax/media';
            }
        } else if(this.state.media_details.primary_button_action == 'update') {
            url = '/ajax/media/' + this.props.match.params.id + '/update';
        } else if(this.state.media_details.primary_button_action == 'edit') {
            var base_url = (this.props.match.url).split('/')[1]
            this.props.history.push("/" + base_url + '/media_modal/' + this.props.match.params.id + '/edit');
        }

        if(url != '') {
            axios({
                method: 'post',
                url: url,
                data: this.state.form_details,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then((response) => {
                if (self.props.userSession.user.user_type === constants.user_type.user) {
                    
                    if (self.props.endUser.outstanding_bookings) {
                        var media_list = self.props.endUser.outstanding_bookings
                        for (var i = 0; i < media_list.length; i++) {
                            if (self.props.match.params.id !== undefined && self.props.match.params.id === media_list[i].BOOK_ID) {
                                media_list.splice(i, 1);
                            } else if (media_list[i].V_ID === self.state.form_details.vehicle && media_list[i].Profile_ID === self.state.form_details.user) {
                                media_list.splice(i, 1);
                            }
                        }
        
                        self.props.dispatch(setListEndUser("SET_OUTSTANDING_BOOKINGS_LIST", media_list))
        
                    }

                    if (self.props.endUser.dismissed_bookings) {
                        var media_list = self.props.endUser.dismissed_bookings
                        for (var i = 0; i < media_list.length; i++) {
                            if (self.props.match.params.id !== undefined && self.props.match.params.id === media_list[i].BOOK_ID) {
                                media_list.splice(i, 1);
                            } else if (media_list[i].V_ID === self.state.form_details.vehicle && media_list[i].Profile_ID === self.state.form_details.user) {
                                media_list.splice(i, 1);
                            }
                        }
        
                        self.props.dispatch(setListEndUser("SET_DISMISSED_BOOKINGS_LIST", media_list))
                    }

                    axios({
                        method: 'get',
                        url: '/ajax/eu-media/outstanding'
                    })
                    .then(function(response2) {
                        self.props.dispatch(setListEndUser("SET_OUTSTANDING_BOOKINGS_LIST", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
    
                    axios({
                        method: 'get',
                        url: '/ajax/eu-media/completed'
                    })
                    .then(function(response2) {
                        self.props.dispatch(setListEndUser("SET_COMPLETED_MEDIA_LIST", response2.data))
            
                        self.setState({
                            loaded: true
                        })
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
    
                    axios({
                        method: 'get',
                        url: '/ajax/eu-media/dismissed'
                    })
                    .then(function(response2) {
                        self.props.dispatch(setListEndUser("SET_DISMISSED_BOOKINGS_LIST", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })

                    axios.get('/ajax/eu-home/sidebar')
                    .then(function(response) {
                        checkCredentials(response);
                        if (! ("status" in response?.data)) {
                            self.props.dispatch(setSidebar(response))
                        }
                    })

                } else {
                    var url_array = self.props.match.url.split("/")
                    if (url_array[1] === "mediaoverview") {
                        axios({
                            method: 'post',
                            url: '/ajax/medialist/outstanding'
                        })
                        .then(function(response2) {
                            self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response2.data.outstanding_bookings))
                        })
                        .catch(function(error) {
                            if(error.response?.status == 401){
                                showStatusMsg(error.response?.data.error);
                            } else if(error.response?.status == 422) {
                                var error_message = "";
            
                                $.each(error.response?.data.errors, function (index, element) {
                                    error_message += element + '<br />';
                                });
            
                                showStatusMsg(error_message);
                            } else {
                                showStatusMsg("Requested information not found");
                            }
                        })
        
                        axios({
                            method: 'post',
                            url: '/ajax/medialist/completed'
                        })
                        .then(function(response2) {
                            self.props.dispatch(setList("SET_COMPLETED_MEDIA_LIST", response2.data.completed_media))
                
                            self.setState({
                                loaded: true
                            })
                        })
                        .catch(function(error) {
                            if(error.response?.status == 401){
                                showStatusMsg(error.response?.data.error);
                            } else if(error.response?.status == 422) {
                                var error_message = "";
            
                                $.each(error.response?.data.errors, function (index, element) {
                                    error_message += element + '<br />';
                                });
            
                                showStatusMsg(error_message);
                            } else {
                                showStatusMsg("Requested information not found");
                            }
                        })
        
                        axios({
                            method: 'post',
                            url: '/ajax/medialist/dismissed'
                        })
                        .then(function(response) {
                            self.props.dispatch(setList("SET_DISMISSED_MEDIA_LIST", response?.data.dismissed_bookings))
                        })
                        .catch(function(error) {
                            if(error.response?.status == 401){
                                showStatusMsg(error.response?.data.error);
                            } else if(error.response?.status == 422) {
                                var error_message = "";
            
                                $.each(error.response?.data.errors, function (index, element) {
                                    error_message += element + '<br />';
                                });
            
                                showStatusMsg(error_message);
                            } else {
                                showStatusMsg("Requested information not found");
                            }
                        })
                    }

                    if (url_array.length > 1 && url_array[2] === "vehicle") {
                        axios.get('/ajax/vehicle/' + url_array[3])
                        .then(function(response2) {
                            self.props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                        })
                        .catch(function(error) {
                            if(error.response?.status == 401){
                                showStatusMsg(error.response?.data.error);
                            } else if(error.response?.status == 422) {
                                var error_message = "";
            
                                $.each(error.response?.data.errors, function (index, element) {
                                    error_message += element + '<br />';
                                });
            
                                showStatusMsg(error_message);
                            } else {
                                showStatusMsg("Requested information not found");
                            }
                        })
                    } else if (url_array.length > 1 && url_array[2] === "profile") {
                        axios.get('/ajax/profile/' + url_array[3])
                        .then(function(response2) {
                            self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                        })
                        .catch(function(error) {
                            if(error.response2.status == 401){
                                showStatusMsg(error.response2.data.error);
                            } else if(error.response?.status == 422) {
                                var error_message = "";
            
                                $.each(error.response2.data.errors, function (index, element) {
                                    error_message += element + '<br />';
                                });
            
                                showStatusMsg(error_message);
                            } else {
                                showStatusMsg("Requested information not found");
                            }
                        })
                    }

                }
                self.props.history.goBack();
                showStatusMsg(response?.data.message, 'success');
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else {
            axios.get("ajax/media/" + this.props.match.params.id + "/edit")
            .then((response) => {

                var media_list = self.props.stakeholder.completed_media_list

                for (var i = 0; i < media_list.length; i++) {
                    if (self.props.match.params.id === media_list[i].ID) {
                        media_list[i].active_rating = self.state.form_details.rating_check
                        media_list[i].rating = self.state.form_details.media_rating
                        media_list[i].date_published = self.state.form_details.date_published
                        media_list[i].link = self.state.form_details.link 
                        media_list[i].title = self.state.form_details.title
                    } 
                }

                self.props.dispatch(setList("SET_COMPLETED_MEDIA_LIST", media_list))

                self.state.form_details.user = response?.data.view.users[0].ID;
                self.state.selectedUser = {label: response?.data.view.users[0].First_Name + " " + response?.data.view.users[0].Last_Name, value: response?.data.view.users[0].ID};
                self.state.form_details.vehicle = response?.data.view.vehicles[0].V_ID;
                self.state.selectedVehicle = {label: response?.data.view.vehicles[0].Year + " " + response?.data.view.vehicles[0].Make + " " + response?.data.view.vehicles[0].Model + " " + response?.data.view.vehicles[0].Trim, value: response?.data.view.vehicles[0].V_ID};

                self.state.form_details.link = response?.data.view.media.link;
                self.state.form_details.title = response?.data.view.media.title;
                self.state.form_details.date_published = response?.data.view.media.date_published;
                self.state.form_details.rating_check = response?.data.view.media.active_rating;
                self.state.form_details.media_rating = response?.data.view.media.rating;
                self.state.form_details.description = response?.data.view.media.description;

                axios({
                    method: 'post',
                    url: '/ajax/medialist/completed'
                })
                .then(function(response2) {
                    self.props.dispatch(setList("SET_COMPLETED_MEDIA_LIST", response2.data.completed_media))
        
                    self.setState({
                        loaded: true
                    })
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
                self.setState({
                    media_details: response?.data.view,
                    loaded_media: true
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
    }

    changeRating(value) {
        var form_details = this.state.form_details

        form_details["media_rating"] = value

        this.setState({
            form_details: form_details
        })
    }

    returnRatingSpan(rating) {
        if (rating < 25) {
            return (<span className = "mediarating-text very-bad"><Trans>Negative</Trans></span>)
        } else if (rating < 50) {
            return(<span className = "mediarating-text bad"><Trans>Somewhat Negative</Trans></span>)
        } else if (rating < 75) {
            return(<span className = "mediarating-text neutral"><Trans>Neutral</Trans></span>)
        } else if (rating < 100) {
            return(<span className = "mediarating-text good"><Trans>Somewhat Positive</Trans></span>)
        } else if (rating === 100) {
            return(<span className = "mediarating-text excellent"><Trans>Positive</Trans></span>)
        }
    }


    render(props) {
        if(this.state.loaded_media) {
            return (
                <div id = "media-overlay">
                    <div className="card-section">
                        <div className="form-container row collapse">
                            <div className="column large-6 medium-6 small-12">
                                <label><Trans>User</Trans> <span className="type-alert">*</span>
                                    <div className = "form-95">
                                        <Select
                                            options={
                                                this.state.media_details.users.map((user, i) => ({label: user.First_Name + " " + user.Last_Name, value: user.ID}))
                                            } 
                                            onChange={this.updateUser}
                                            value={this.state.selectedUser}
                                            isDisabled={ this.state.media_details.disabled.user }
                                            className = "react_select_dropdown"
                                            classNamePrefix="react_select"
                                        />
                                    </div>
                                </label>
                            </div>
                            <div className="column large-6 medium-6 small-12">
                                <label><Trans>Vehicle</Trans> <span className="type-alert">*</span>
                                    <Select
                                        options={
                                            this.state.media_details.vehicles.length > 0 ? 
                                                    this.state.media_details.vehicles.map((vehicle, i) => ({label: vehicle.Year + " " + vehicle.Make + " " + vehicle.Model + " " + vehicle.Trim, value: vehicle.V_ID}))
                                                :
                                                    ([{}])
                                        } 
                                        onChange={this.updateVehicle}
                                        value={this.state.selectedVehicle}
                                        isDisabled={ this.state.media_details.disabled.vehicle }
                                        className = "react_select_dropdown"
                                        classNamePrefix="react_select"
                                    />
                                </label>
                            </div>
                            {
                                this.state.media_details.oem_user ?
                                        <div className="caption mb-16"><Trans>You can only select users/vehicles that have outstanding media.</Trans></div>
                                    :
                                        <span />
                            }
                            <div className="column large-12 medium-12 small-12">
                                <label>Link <span className="type-alert">*</span>
                                    <input type="text" name="link" name="link" defaultValue={ this.state.media_details.media.link} disabled={ this.state.media_details.disabled.link } onChange={this.updateForm} />
                                </label>
                            </div>
                            <div className="column large-12 medium-12 small-12">
                                <label><Trans>Title</Trans> <span className="type-alert">*</span>
                                    <input type="text" name="title" name="title" defaultValue={ this.state.media_details.media.title} disabled={ this.state.media_details.disabled.title } onChange={this.updateForm} />
                                </label>
                            </div>
                            <div className={"column " + (this.state.media_details.oem_user ? "large-6" : "large-12") + " medium-6 small-12 date-published"}>
                                <label><Trans>Date Published</Trans>
                                    <DatePicker id="media_date_published" classname={"datepicker date-input-field date-field no-margin " + (this.state.media_details.oem_user ? "form-95" : "")} name="date_published" value={this.state.media_details.media.date_published} disabled={this.state.media_details.disabled.date_published} updateValue={this.updateForm} />
                                </label>
                            </div>
                            {
                                this.state.media_details.oem_user ?
                                    <div className="column large-6 medium-6 small-12">
                                        <h6 className = "float-left"><Trans>Media Rating</Trans></h6>
                                        {
                                            !this.state.media_details.disabled.media_rating ?
                                                <label className="switch float-right">
                                                    <input className="media-switch" type="checkbox" disabled={this.state.media_details.disabled.media_rating} name="rating_check" defaultChecked={this.state.media_details.media.active_rating} onChange={this.updateForm} />
                                                    <span className="switch-slider round"></span>
                                                </label>
                                            :
                                                <span />
                                        }
                                        <div className="clearfix"></div>
                                        {
                                            this.state.form_details.rating_check ?
                                                <div>
                                                    {this.returnRatingSpan(this.state.form_details.media_rating)}
                                                    <div className = "mt-4 mediarating-slider">
                                                        <Slider min={0} max={100} step={25} dots disabled={this.state.media_details.disabled.media_rating} defaultValue={this.state.media_details.media.rating} onChange={this.changeRating}/>
                                                    </div>
                                                </div>
                                                :
                                            null
                                        }
                                    </div>
                                :
                                    <span />
                            }
                            <div className="column large-12 medium-12 small-12">
                                <label><Trans>Description</Trans>
                                    <textarea className="no-margin" placeholder="A brief summary of the Media." name="description" disabled={this.state.media_details.disabled.description} defaultValue={this.state.media_details.media.description} onChange={this.updateForm} />
                                </label>
                                {
                                    this.state.media_details.oem_user ?
                                        <div className="caption mt-8"><Trans>Both you and the user will see the description.</Trans></div>
                                    :
                                        <span />
                                }
                            </div>
                        </div>
                    </div>
                    <div className = "card-button-section">
                        <a className = "button primary float-right" onClick={this.handleSubmit}>{this.state.media_details.primary_button}</a>
                        <a className = "button float-right" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a>
                        <div className = "clearfix"></div>
                    </div>
                </div>
            )
        } else {
            return (
                <div id = "media-overlay">
                    <div className="card-section">
                        <LoadingIcon />
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder,
    endUser: store.endUser
})

export default connect(mapStateToProps)(MediaOverlay)